import { Routes, Route, useNavigate } from 'react-router-dom';
import Dashboard from '../pages/Dashboard';
import Contrato from '../pages/contratos/Contrato';
import Core from '../core/Core';
import ResetPassword from '../components/auth/ResetPassword';
import Login from '../components/auth/Login';
import NewPassword from '../components/auth/NewPassword';
import PrivateRoute from './PrivateRoutes';
import BilletesEnCaja from '../pages/corte/BilletesEnCaja';
import BusquedasRealizadas from '../pages/corte/BusquedasRealizadas';
import Transferencias from '../pages/corte/Transferencias';
import IngrsEgrs from '../pages/corte/IngrsEgrs';
import ContentHTML from "../components/helpers/ContentHTML";
import Todo from "../pages/todo/Todo";
import Ticket from "../pages/ticket/Ticket";
import { useEffect } from "react";
import { setNavigate } from "../components/helpers/navigation";
import Resumen from "../pages/corte/Resumen";
import NotFound from "../pages/NotFound";
export default function CamelusRoutes(){

    const navigate = useNavigate();

    useEffect(() => {
        setNavigate(navigate);
    }, [navigate]);

    return(
        <>
            <Routes>
                <Route path='/' element={<Login></Login>}/>
                <Route path='/reset-password' element={<ResetPassword></ResetPassword>}/>
                <Route path='/new-password' element={<NewPassword></NewPassword>}/>
                <Route path={'*'} element={<NotFound/>}></Route>
               {/* Redirect to Dashboard after login/registartion */}
                <Route element={<PrivateRoute/>}>
                    <Route element={<Core></Core>}>
                        <Route path='/corte/corte-de-caja' element={<BilletesEnCaja/>}/>
                        <Route path='/corte/otros-conceptos' element={<IngrsEgrs/>}/>
                        <Route path='/corte/resumen' element={<Resumen/>}/>
                        <Route path='/corte/busquedas-realizadas' element={<BusquedasRealizadas/>}/>
                        <Route path='/corte/traslados' element={<Transferencias />} />
                        <Route path='/dashboard' element={<Dashboard/>}/>
                        <Route path='/contrato/:elementId' element={<Contrato/>}/>
                        <Route path={'/content'} element={<ContentHTML/>} />
                        <Route path={'/todo/:tabId'} element={<Todo/>}/>
                        <Route path={'/tickets'} element={<Ticket/>}></Route>
                    </Route>
                </Route>
            </Routes>
        </>
    );
}
